"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultBrdGrid = exports.DefaultSchGrid = void 0;
exports.parseKicadLineType = parseKicadLineType;
exports.parseStrokeDirective = parseStrokeDirective;
exports.parseFillDirective = parseFillDirective;
exports.DefaultSchGrid = {
    distance: 1.27,
    units: 'mm',
    invertY: true,
};
exports.DefaultBrdGrid = {
    distance: 1.27,
    units: 'mm',
    invertY: true,
};
function parseKicadLineType(lineTypeStr) {
    switch (lineTypeStr) {
        case 'dash':
        case 'dot':
            return lineTypeStr;
        case 'dash_dot':
            return 'dash-dot';
        case 'solid':
        default:
            return 'solid';
    }
}
function parseStrokeDirective(n) {
    const stroke = {
        width: 0,
        type: 'solid',
    };
    const widthNode = n.nodes.find((v) => v.name === 'width');
    if (widthNode) {
        stroke.width = parseFloat(widthNode.values[0]);
    }
    const typeNode = n.nodes.find((v) => v.name === 'type');
    if (typeNode) {
        stroke.type = parseKicadLineType(typeNode.values[0]);
    }
    return stroke;
}
function parseFillDirective(n, layerSelector, defaultLayer) {
    const typeNode = n.nodes.find((v) => v.name === 'type');
    let filled;
    let fillLayer;
    let colorOverride;
    if (typeNode) {
        filled = typeNode.values[0] === 'none' ? undefined : 1;
        fillLayer = layerSelector.getLayerByColorType(typeNode.values[0], defaultLayer);
        if (typeNode.values[0] === 'color') {
            const colorNode = n.nodes.find((v) => v.name === 'color');
            if (colorNode) {
                colorOverride = [
                    parseInt(colorNode.values[0]),
                    parseInt(colorNode.values[1]),
                    parseInt(colorNode.values[2]),
                    parseInt(colorNode.values[3]),
                ];
            }
        }
    }
    else if (n.values.length > 0) {
        filled = n.values[0] === 'none' ? undefined : 1;
        fillLayer = layerSelector.getLayerByColorType(n.values[0], defaultLayer);
    }
    return {
        filled,
        layer: fillLayer || layerSelector.getLayerByType(defaultLayer),
        colorOverride,
    };
}
//# sourceMappingURL=v6Common.js.map